/**
 * react-hook-form helpers shared by migrated forms.
 */
import FormValidator from "@/helpers/formValidater";
import type { FieldErrors, Resolver } from "react-hook-form";

/**
 * Build an RHF resolver from FormValidator field keys (+ optional cross-field logic).
 * Preserves existing FormValidator messages and rules.
 */
export function createFormValidatorResolver(
  fields: string[],
  extraValidate?: (values: Record<string, any>, errors: Record<string, string>) => Record<string, string>
): Resolver<any> {
  return (values) => {
    let errors = fields.reduce(
      (acc, field) => ({ ...acc, ...FormValidator(field, values) }),
      {} as Record<string, string>
    );
    if (extraValidate) {
      errors = extraValidate(values, errors);
    }
    const rhfErrors: FieldErrors = {};
    for (const [key, message] of Object.entries(errors)) {
      if (message) {
        rhfErrors[key] = { type: "validate", message: String(message) };
      }
    }
    const hasErrors = Object.keys(rhfErrors).length > 0;
    return hasErrors
      ? { values: {} as Record<string, never>, errors: rhfErrors }
      : { values, errors: {} };
  };
}
